import React, { useState, useRef, useEffect } from 'react';
// import {useSelector} from 'react-redux';
import {Routes, Route, Outlet } from 'react-router-dom'
import ProtectedRoute from "./Authentication Services/ProtectedRoute";
import AuthenticationRouteGuard from './Authentication Services/AuthenticationRouteGuard'
import Sidebar from "./Components/Sidebar/SideBar";
import Header from './Components/Header/Header';
// import "./index.css";
// import "./chart.css";
// import "./step.css";
// import Nav from "./Components/nav";
// import ScrollToTop from "./layouts/ScrollToTop";
import Registration from "./Pages/Auth/Registration";
import Login from "./Pages/Auth/Login";
// import LockScreen from "./pages/LockScreen";
// import Error400 from "./pages/Error400";
// import Error403 from "./pages/Error403";
// import Error404 from "./pages/Error404";
// import Error500 from "./pages/Error500";
// import Error503 from "./pages/Error503";
import ManageServices from './Pages/Services/ManageServices';
import ManageStaff from './Pages/Staff/Staff';
import Settings from './Pages/Settings/Settings';
import Overview from "./Pages/Overview/Overview";
// import Calendar from "./components/Barber/Calendar/Calendar"
import CalendarComponent from './Pages/Calendar/Calendar';
import Search from './Pages/Search/Search';
import MakeBooking from './MakeBooking/MakeBooking';
import MiniSite from './Pages/MiniSite/MiniSite';
import CancelAppointment from './Pages/CancelAppointment/CancelAppointment';
import Support from './Pages/Support/Support';
// import LandingPage from "./components/Barber/HomePage/LandingPage"
import RequestForgotPassword from "./Pages/ForgotPassword/RequestForgotPassword";
import ResetPassword from "./Pages/ForgotPassword/ResetPassword";
// import { ThemeContext } from "/Context/ThemeContext";
import SiteLoader from './ClientSite/SiteLoader';
import OnlineBooking from './Pages/OnlineBooking/OnlineBooking';
// import Roster from "./components/Barber/Roster/Roster";
import Roster from './Pages/Roster/Roster';
const Markup = () => {  

  const allroutes = [
    { url:"manage-services", component: <ManageServices /> },
    { url:"manage-staff", component: <ManageStaff /> },
    { url:"", component: <Overview /> },
    { url:"calendar", component: <CalendarComponent /> },
    { url:"search", component: <Search /> },
    { url:"manage-site", component: <MiniSite /> },
    { url:"settings", component: <Settings /> },
    { url:"support", component: <Support /> },
    { url:"online-booking", component: <OnlineBooking /> },
    { url:"roster", component: <Roster /> },
  ];
  return (    
  <>
    <Routes>
      <Route path='make-a-booking' element= {<MakeBooking />} />
      <Route path='client-site' element= {<SiteLoader />} />
      <Route path='cancel-appointment' element= {<CancelAppointment />} />
      {/* <Route path='landing-page' element= {<LandingPage />} /> */}
      <Route path='request-forgot-password' element= {<RequestForgotPassword />} />
      <Route path='reset-password' element= {<ResetPassword />} />
      <Route exact path='register' element= {
        <AuthenticationRouteGuard>
          <Registration />
        </AuthenticationRouteGuard>
      } />
      <Route path='login' element= {
        <AuthenticationRouteGuard>
          <Login />
        </AuthenticationRouteGuard>
      } />
    </Routes>
    <ProtectedRoute>
      <Routes>
        {/* <Route path='page-lock-screen' element= {<LockScreen />} />
        <Route path='page-error-400' element={<Error400/>} />
        <Route path='page-error-403' element={<Error403/>} />
        <Route path='page-error-404' element={<Error404/>} />
        <Route path='page-error-500' element={<Error500/>} />
        <Route path='page-error-503' element={<Error503/>} /> */}
        <Route  element={<MainLayout />} >
        {allroutes.map((data, i) => (
          <Route
          key={i}
          exact
          path={`${data.url}`}
          element={
            data.component
          }
          />
        ))}
        </Route>
      </Routes>

    </ProtectedRoute>
    {/* <ScrollToTop />  */}
    </>
  );
};
function MainLayout(){
  const sidebarRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false)
  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };
  
  useEffect(() => {
    
    const handleClickOutside = (event) => {
    const isClickInsideSidebar = sidebarRef.current?.contains(event.target);
    const isClickOnHamburger = event.target.closest('#hamburger-toggle');
      // console.log(sidebarRef.current)
      if (
      !isClickInsideSidebar &&
      !isClickOnHamburger
      // isSidebarOpen
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // const {sidebariconHover} = useContext(ThemeContext);
  // const sideMenu = useSelector(state => state.sideMenu);
  return (
    <>      
    {/* <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ !sideMenu ? "menu-toggle" : ""}`}> */}
    <div id="main-wrapper" className="layout-wrapper main-background">  
      {/* <Nav /> */}
      
      <Sidebar loggingOut={setLoggingOut} menuState={setIsSidebarOpen} isOpen={isSidebarOpen} ref={sidebarRef} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className={`content-body main-content ${isSidebarOpen ? 'shifted' : ''}`} style={{ minHeight: window.screen.height - 60 }}>
        <Header toggleSidebar={toggleSidebar} />
        <div className="container-fluid mt-3">
        {loggingOut === true ? 
        <div className="custom-loader-wrapper">
                      <div className="custom-loader"></div>
                    </div>
                    :
          <Outlet />       
        }         
        </div>
      </div>
    </div>
    </>
  )
};

export default Markup;